import React from 'react';
import { number, string } from 'prop-types';

const Quotes = ({
  width, height, viewBox, fill,
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox}>
    <path fill={fill} d="M17 0v10.745c0 4.173-.729 7.931-2.186 11.277-1.457 3.346-3.926 6.672-7.407 9.978l-6.193-4.723c1.943-2.047 3.44-3.936 4.493-5.668 1.053-1.732 1.74-3.503 2.064-5.314H0V0h17zm23 0v10.745c0 4.173-.729 7.931-2.186 11.277-1.457 3.346-3.926 6.672-7.407 9.978l-6.193-4.723c1.943-2.047 3.44-3.936 4.493-5.668 1.053-1.732 1.74-3.503 2.064-5.314H23V0h17z" />
  </svg>
);

Quotes.propTypes = {
  width: number,
  height: number,
  viewBox: string,
  fill: string,
};

Quotes.defaultProps = {
  width: 40,
  height: 32,
  viewBox: '0 0 40 32',
  fill: '#e5e5e5',
};

export default Quotes;
